(function () {
  'use strict';

  angular
    .module('scorm.scormCtrl')
    .service('scormCommService', scormCommService);

  var lessonStatusMap = [
    'passed',
    'failed',
    'completed',
    'incomplete',
    'not attempted',
    'browsed'
  ];

  scormCommService.$inject = ['$window'];

  function scormCommService($window) {
    var self = this;

    self.sendMessage = angular.noop;

    self.checkScoComplete = function (props, scormType) {
      // so if this happens we should just set to ready because
      // something bad happened
      if (!props) {
        return self.setScoComplete();
      }

      if (!props['cmi.core.lesson_status'] ||
        props['cmi.core.lesson_status'] === 'not attempted') {
        return self.setScoIncomplete();
      }

      if (scormType === 'camtasia_quiz') {
        // Scorm without a quiz and no completion percentage
        return props['cmi.suspend_data'] >= 0.98 ? self.setScoComplete() : self.setScoIncomplete();
      }

      if (!_.includes(lessonStatusMap, props['cmi.core.lesson_status'])) {
        return;
      }

      if (props['cmi.core.lesson_status'] !== 'incomplete') {
        return self.setScoComplete();
      }

      return self.setScoIncomplete();
    };


    self.requestSetup = function (props, contentUrl, scormType) {
      var name = $window.mfConfig.firstName + " " + $window.mfConfig.lastName;
      var userId = $window.mfConfig.userId;
      // this is needed for scorm to properly initialize
      _.defaults(props, {
        'cmi.core.lesson_status': 'not attempted',
        'cmi.suspend_data': '',
        'cmi.core.student_name': name || 'trainee',
        'cmi.core.student_id': userId || '1'
      });

      self.sendMessage({
        type: 'setup',
        message: {
          contentUrl: contentUrl,
          scoProperties: props
        }
      });

      self.checkScoComplete(props, scormType);
    };

    self.setScoComplete = function () {
      return 'ready';
    };

    self.setScoIncomplete = function () {
      return 'not-ready';
    };
  }
})();
